import ELibrary from "../assets/Projects/E-Library-Books-06-26-2025_05_16_PM.png"
import ParcInfromatique from "../assets/Projects/Parc Informatique.png"

import TechnoTech from "../assets/Projects/Techno-Tech-06-26-2025_05_22_PM.png"
import  offpt from "../assets/education/OFPPT.png"
import  estK from "../assets/education/Logo-ESEF-Kenitra.png"
import  EnsaA from "../assets/education/ensa_logo.png"
import  JobStartImage from "../assets/Projects/JobStartImage.png"

export const Bio = {
    name: "Reda Ganoutre",
    roles: [
      "Full Stack Developer",
      "Android Developer",
      "UI/UX Designer",
      "Programmer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/Reda-Ganoutre01",
    resume:
      "https://drive.google.com/file/d/10B11dC7XagapjNSEHqE90GIhxKKRXwe2/view ",
    linkedin: "https://www.linkedin.com/in/reda-ganoutre-8796262b6/",
    email: "bganoutre52@gmail.com",
    whatsapp: "https://wa.me/212762666115",
    twitter: "",
    insta: "",
    facebook: "",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React Js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
        },
        {
          name: "Redux",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
        },
        {
          name: "Next Js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
        },
        {
          name: "HTML",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
        },
        {
          name: "CSS",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
        },
        {
          name: "JavaScript",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
        },
        {
          name: "Bootstrap",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
        },
        {
          name: "Tailwind CSS",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
        }
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
        },
        {
          name: "Laravel",
          image: "https://laravel.com/img/logomark.min.svg",
        },
        {
          name: "PHP",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
         
        },
        {
          name: "Spring Boot",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
        },
        {
          name: "Java",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
        },
        {
          name: "Express Js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
        },
        {
          name: "Python",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
        },
      
      ],
    },

    {
      title: "BD",
      skills: [
       
        {
          name: "MySQL",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
        },
        {
          name: "Oracle",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg",
        },
        {
          name: "MongoDB",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
        },
      ],
    },
    {
      title: "Android",
      skills: [
        {
          name: "React Native",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
        },
      ],
    },
    {
      title: "Testing",
      skills: [
        {
          name: "Selenium",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/selenium/selenium-original.svg",
        },
        {
          name: "jUnit",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/junit/junit-original.svg",
        },
        {
          name: "SonarQube",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sonarqube/sonarqube-original.svg",
        },
      ],
    },
    {
      title: "DevOps",
      skills: [
        {
          name: "Git",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
        },
        {
          name: "GitHub",
          image: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
        },
        {
          name: "GitHub Actions",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/githubactions/githubactions-original.svg",
        }
      ],
    },
    {
      title: "Others",
      skills: [{
          name: "Postman",
          image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
        },
        {
          name: "Blender",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/blender/blender-original.svg",
        },
        {
          name: "Figma",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
        },
        {
          name: "GitLab",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg",
        },
        {
          name: "Trello",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/trello/trello-plain.svg",
        },
        {
          name: "Jira",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg",
        },
      ],
    },
  ];
  export const experiences = [
    {
      id: 0,
      img: "https://casainvest.ma/sites/default/files/2022-01/environnement.png",
      role: "Full Stack Developer Intern",
      company: "Ministère de la Transition Energétique et du Développement Durable - Royaume du Maroc.",
      date: "avr 2024 - Mai 2024",
      desc: "Development of a web application added to the information site in the park. The main objective of this project is optimized for the suivi and distribution of resource materials.",
      skills: [
        "Laravel", "MySql", "HTML", "JavaScript", "Bootstrap", "Git", "GitHub",
      ],
      doc: "https://drive.google.com/file/d/1VXeuFNyn8dWEFDg-ZXgBmQs1d4kigUkv/view",
    },
   
  ];
  
  export const education = [
    {
      id: 0,
      img: offpt,
      school: "Institut Spécialisé de Technologie Appliquée NTIC",
      date: "Sep 2022 - Juin 2024",
      grade: "Mention Très Bien",
      desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
      degree: "Développement Digital option Web Full Stack",
    },
    {
      id: 1,
      img: estK,
      school: "Ecole Supérieure de Technologie Kénitra",
      date: "Nov 2024 - July 2025",
      grade: "Mention Bien",
      desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
      degree: "Licence Génie Informatique et Gouvernance Digitale",
    },{
      id: 2,
      img: EnsaA,
      school: "Ecole Nationale des Sciences Appliquées - Agadir",
      date: "Sep 2025",
      // grade: "",
      // desc: "",
      degree: "Software & Application Development Engineer",
    },
  ];
  export const projects = [
   
    // E-Library Project
    {
      id: 0,
      title: "Advanced Library Management System",
      date: "Jan  2025 - May 2025",
      description:
        "advanced library management system designed to streamline library operations, including book search, reservations, user management, and more. The backend is built using Spring Boot, and the frontend is developed with React. Below is an overview of the project structure, features, and setup instructions.",
      image:ELibrary,
      tags: ["React JS", "Spring Boot", "Redux Toolkit", "MySQL", "Docker", "GitHub Actions", "Selenium", "JUnit", "SonarQube"],
      category: "web app",
      github: "https://github.com/Reda-Ganoutre01/E-Library",
      webapp: "https://E-Library.netlify.app/",
      member: [
        {
          name: "REDA GANOUTRE",
          img: "https://avatars.githubusercontent.com/u/121640970?v=4",
          linkedin: "https://www.linkedin.com/in/reda-ganoutre-8796262b6/",
          github: "https://github.com/Reda-Ganoutre01",
        },
        {
          name: "MOHAMED LAFROUH",
          img: "https://avatars.githubusercontent.com/u/59917135?v=4",
          linkedin: "",
          github: "https://github.com/AmbitiousFlow",
        },
      ],
    },
    {
      id: 0,
      title: "Ecommerce Techno Tech",
      date: "Jan  2024 - May 2024",
      description:
        "Ecommerce Techno Tech is a web-based e-commerce platform designed for gaming enthusiasts. The platform provides a seamless shopping experience for users to browse, search, and purchase gaming-related products. It also includes an admin panel for managing the store's inventory, orders, and promotions. The project was built with scalability and main.",
      image:TechnoTech,
      tags: ["PHP", "JavaScript", "MySQL", "Css"],
      category: "web app",
      github: "https://github.com/Reda-Ganoutre01/Ecommerce-Techno-Tech",
      webapp: "https://techno-tech.lovestoblog.com/",
      member: [
        {
          name: "REDA GANOUTRE",
          img: "https://avatars.githubusercontent.com/u/121640970?v=4",
          linkedin: "https://www.linkedin.com/in/reda-ganoutre-8796262b6/",
          github: "https://github.com/Reda-Ganoutre01",
        },
        {
          name: "Adnane Benmalek",
          img: "https://avatars.githubusercontent.com/u/122831381?v=4",
          linkedin: "https://www.linkedin.com/in/adnane-benmalek-b933412b7/",
          github: "https://github.com/adnanebnmlk",
        },
      ],
    },
    {
      id: 1,
      title: "Gestion De Parc Informatique",
      date: "avr 2024 - Mai 2024",
      description:
        "La gestion de parc informatique vise à organiser et superviser l’ensemble des activités liées aux équipements informatiques d’une organisation. Elle permet de suivre l’inventaire, gérer les affectations et interventions, tout en optimisant les ressources. Ce projet repose sur une planification rigoureuse, une coordination efficace et une communication continue, dans le but d’améliorer la performance, la sécurité et la prise de décision.",
      image:ParcInfromatique,
      tags: ["Laravel", "JavaScript", "MySQL", "BootStrap", "Git"],
      category: "web app",
      github: "https://github.com/Reda-Ganoutre01/gestion_parc_informatique",
      webapp: ""
    },
   {
  id: 2,
  title: "JobStart – Static Job Board Platform",
  date: "oct 2025 - dec 2025",
  description:
    "JobStart est une plateforme moderne de diffusion d’offres d’emploi, entièrement statique et développée avec HTML, CSS et JavaScript pur. Le projet permet aux candidats de consulter et rechercher des offres, et aux recruteurs de publier des annonces via des formulaires dédiés. Il met l’accent sur la performance, la simplicité, le responsive design et une architecture modulaire sans frameworks ni dépendances externes.",
  image: JobStartImage,

  tags: [
    "HTML5",
    "CSS3",
    "JavaScript",
    "Vanilla JS",
    "Responsive Design",
    "Git"
  ],
  category: "web app",
  github: "https://github.com/Reda-Ganoutre01/JobStart",
  webapp: "https://jobstarrt.netlify.app/",
      member: [
        {
          name: "REDA GANOUTRE",
          img: "https://avatars.githubusercontent.com/u/121640970?v=4",
          linkedin: "https://www.linkedin.com/in/reda-ganoutre-8796262b6/",
          github: "https://github.com/Reda-Ganoutre01",
        },
        {
          name: "Elmeliani-y",
          img: "https://avatars.githubusercontent.com/u/119269216?v=4",
          linkedin: "",
          github: "https://github.com/Elmeliani-y",
        },
      ],
}

    // {
    //   id: 7,
    //   title: "Quiz App",
    //   date: "Dec 2020 - Jan 2021",
    //   description:
    //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    //   image:
    //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Quiz-Earn",
    //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
    // }

    
    // {
    //   id: 1,
    //   title: "Vexa",
    //   date: "Oct 2022 - Present",
    //   description:
    //     "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
    //   image:
    //     "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    //   tags: [
    //     "React Js",
    //     "MongoDb",
    //     "Node Js",
    //     "Express Js",
    //     "Redux",
    //     "NodeMailer",
    //   ],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Project-Management-App",
    //   webapp: "https://vexa-app.netlify.app/",
    // },
    // {
    //   id: 2,
    //   title: "Brain Tumor Detection",
    //   date: "Jan 2023 - Mar 2023",
    //   description:
    //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    //   image:
    //     "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    //   category: "machine learning",
    //   github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    //   webapp: "https://brain-tumor.netlify.app/",
    //   member: [
    //     {
    //       name: "Rishav Chanda",
    //       img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //       github: "https://github.com/rishavchanda/",
    //     },
    //     {
    //       name: "Upasana Chaudhuri",
    //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //       github: "https://github.com/upasana0710",
    //     },
    //   ],
    // },
    // {
    //   id: 3,
    //   title: "Buckoid",
    //   date: "Dec 2021 - Apr 2022",
    //   description:
    //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
    //   image:
    //     "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
    //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
    // },
    // {
    //   id: 10,
    //   title: "Job Finding App",
    //   date: "Jun 2023 - Jul 2023",
    //   description:
    //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    //   image:
    //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    //   tags: ["React Native", "JavaScript", "Axios"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Job-finder-App",
    //   webapp: "https://github.com/rishavchanda/Job-finder-App",
    // },
    // {
    //   id: 4,
    //   title: "Whatsapp Clone",
    //   date: "Jul 2021",
    //   description:
    //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    //   image:
    //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    //   webapp: "https://whatsapp-clone-rishav.web.app",
    // },
    // {
    //   id: 5,
    //   title: "Todo Web App",
    //   date: "Jun 2021",
    //   description:
    //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    //   image:
    //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Todo-Web-App",
    //   webapp: "https://rishav-react-todo.netlify.app/",
    // },
    // {
    //   id: 6,
    //   title: "Breaking Bad",
    //   date: "Jun 2021",
    //   description:
    //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
    //   image:
    //     "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
    //   tags: ["React Js", "API", "Axios", "Node JS"],
    //   category: "web app",
    //   github: "https://github.com/rishavchanda/Breaking-Bad",
    //   webapp: "https://breaking-bad-webapp.netlify.app",
    // },
    // {
    //   id: 7,
    //   title: "Quiz App",
    //   date: "Dec 2020 - Jan 2021",
    //   description:
    //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    //   image:
    //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    //   category: "android app",
    //   github: "https://github.com/rishavchanda/Quiz-Earn",
    //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
    // },
    // {
    //   id: 8,
    //   title: "Face Recognition",
    //   date: "Jan 2021",
    //   description:
    //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    //   image:
    //     "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
    //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    //   category: "machine learning",
    //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    // },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];
